import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import food_img from '../../assets/food-img.png'
import irctc_logo from '../../assets/IRCTC-Emblem.png'

import {
    setBoardingDate,
    setPnr,
    setStationsDetailAllStart,
    setHomeTab,
    setVersion,
    setTrainNo,
    setBoardingStation,
    removeAllItemFromCart
} from '../../redux/cart/cart.action';
import {
    selectBoardingDate,
    selectCartItemsCount,
    selectPnr,
    selectStations,
    selectVersion,
    selectHomeTab,
    selectTrainNo,
    selectBoardingStation,
    selectStationFetching
} from '../../redux/cart/cart.selector';
import AutoTrain from "../../components/journey-details/autotrain.component";
import AutoStation from "../../components/journey-details/autostation.component";
import DatePicker from "../../components/datapicker/datapicker.component";

import recomndIcon from '../../assets/recmndIcon.svg';
import trndngIcon from '../../assets/trending-icon.svg';
import loader from '../../assets/loader-icon.svg';
import couponBanner from '../../assets/summer15-3 (1).png';
import './home-journey-details.style.css';

class HomeJourneyDetails extends React.Component {
    constructor(props) {
        super(props);
        props.emptyCart();

    }
    componentDidMount() {
        if (this.props.homeTab === '') {
            this.props.setHomeTab('TRAIN');
        }
        if (this.props.cartCount === 0) {
            this.props.setVersion('');
        }
    }
    componentDidUpdate() {
        if (document.getElementById("order-food") && this.props.stationFetching === false) {
            let btn = document.getElementById("order-food");
            btn.className = "proceed-journey";
        }
    }
    afdayDate = () => {
        let today = new Date(new Date().getTime() + 2 * (24 * 60 * 60 * 1000));
        let dd = today.getDate();
        let mm = today.getMonth() + 1;
        let yyyy = today.getFullYear();

        if (dd < 10) {
            dd = "0" + dd;
        }
        if (mm < 10) {
            mm = "0" + mm;
        }
        today = dd + "-" + mm + "-" + yyyy;
        this.props.setDate(today);
    };
    afdayDateRaw = () => {
        let today = new Date(new Date().getTime() + 2 * (24 * 60 * 60 * 1000));
        let dd = today.getDate();
        let mm = today.getMonth() + 1;
        let yyyy = today.getFullYear();
        let month = new Intl.DateTimeFormat('en', { month: 'short' }).format(today);

        if (dd < 10) {
            dd = "0" + dd;
        }
        if (mm < 10) {
            mm = "0" + mm;
        }
        return today = dd + "-" + month + "-" + yyyy;
    };
    trowdate = () => {
        let today = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
        let dd = today.getDate();
        let mm = today.getMonth() + 1;
        let yyyy = today.getFullYear();

        if (dd < 10) {
            dd = "0" + dd;
        }
        if (mm < 10) {
            mm = "0" + mm;
        }
        today = dd + "-" + mm + "-" + yyyy;
        this.props.setDate(today);

    };
    trowdateRaw = () => {
        let today = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
        let dd = today.getDate();
        let mm = today.getMonth() + 1;
        let yyyy = today.getFullYear();
        let month = new Intl.DateTimeFormat('en', { month: 'short' }).format(today);

        if (dd < 10) {
            dd = "0" + dd;
        }
        if (mm < 10) {
            mm = "0" + mm;
        }
        return today = dd + "-" + month + "-" + yyyy;
    };
    formatDate(toDate) {

        const date = new Date(toDate);
        let year = new Intl.DateTimeFormat('en', { year: '2-digit' }).format(date);
        let month = new Intl.DateTimeFormat('en', { month: 'short' }).format(date);
        let day = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(date);
        let weekday = new Intl.DateTimeFormat('en', { weekday: 'short' }).format(date);
        return `<span>${weekday}</span> ${day}`;
    }
    submit = (active) => {

        if (this.props.boardingDate === '' || this.props.boardingDate === undefined) {
            document.getElementById('boarding_date_error').style.display = "block";
        }
        if (active === 'TRAIN') {
            if ((this.props.trainNo === '' || this.props.boardingStation === undefined || this.props.boardingStation === '')) {
                if (this.props.trainNo === '' || this.props.trainNo === undefined) {
                    document.getElementById('train_name_error').style.display = "block";
                }
                if (this.props.boardingStation === '' || this.props.boardingStation === undefined) {
                    document.getElementById('station_name_error').style.display = "block";
                }
                return;
            }
            document.getElementById('station_name_error').style.display = "none";
            document.getElementById('train_name_error').style.display = "none";
            let btn = document.getElementById("order-food");
            btn.className = "proceed-journey loading";
            this.props.setStationAll()
        } else {
            if (this.props.pnr === '' || this.props.pnr === undefined) {
                document.getElementById('pnr_error').style.display = "block";
                document.getElementById('pnr_error').textContent = "Enter PNR number";
                return;
            }
            if (this.props.pnr.length < 10) {
                document.getElementById('pnr_error').style.display = "block";
                document.getElementById('pnr_error').textContent = "PNR must be 10 digits";
                return;
            }
            if (this.props.pnr.length > 10) {
                document.getElementById('pnr_error').style.display = "block";
                document.getElementById('pnr_error').textContent = "Please enter valid PNR";
                return;
            }
            let btn = document.getElementById("order-food");
            btn.className = "proceed-journey loading";
            this.props.setStationAll()
        }
    }
    handleStationToast = () => {
        var x = document.getElementById("stationontoast");
        if (x) {
            x.className = "addontoast show";
            setTimeout(function () {
                x.className = x.className.replace("show", "");
            }, 3000);
        }
    }
    handleChange = (event) => {
        let btn = document.getElementById("order-food");
        btn.className = "proceed-journey loading";
        this.props.setPnr(event.target.value);
        document.getElementById('pnr_error').style.display = "none";
        document.getElementById('station_name_error').style.display = "none";
        document.getElementById('train_name_error').style.display = "none";
    };
    handleClear = async () => {
        await this.props.setPnr('');
        await this.props.setBoardingStation('');
        await this.props.setTrainNo('');
    }
    render() {
        const { pnr, cartCount, stations, homeTab, setHomeTab, version, trainNo, boardingStation } = this.props;
        const tomorrow = this.trowdateRaw();
        const dayAfterTomorrow = this.afdayDateRaw();
        if (cartCount <= 0 || version === '3') {
            return (
                <div className="home-journey-box">
                    <div className="home-search">
                        <div className="switch-btn">
                            <a href="#" className={`${homeTab === 'TRAIN' ? 'enable' : ''}`} onClick={() => setHomeTab('TRAIN')}>TRAIN</a>
                            <a href="#" className={`${homeTab === 'PNR' ? 'enable' : ''}`} onClick={() => setHomeTab('PNR')}>PNR</a>
                        </div>
                        <div className="home-journey-box-1">
                            {homeTab === 'TRAIN' &&
                                <div className="train-details textArea">
                                    <AutoTrain />
                                    <div className="textArea3">
                                        <DatePicker />
                                        <div className="dateBox">
                                            <h4 className="yesterday" onClick={() => this.trowdate()} dangerouslySetInnerHTML={{ __html: this.formatDate(tomorrow) }}></h4>
                                            <h4 className="tomorrow" onClick={() => this.afdayDate()} dangerouslySetInnerHTML={{ __html: this.formatDate(dayAfterTomorrow) }}></h4>
                                        </div>
                                    </div>
                                    <AutoStation />
                                </div>
                            }
                            {homeTab === 'PNR' &&
                                <div className="pnr-details textArea">
                                    <div className={`pnrArea ${(pnr === '' ? 'empty' : '')}`} >
                                        <label >
                                            Enter your PNR number
                                        </label>
                                        <input type="number" id="pnr" name="Pnr" value={pnr} onChange={e => { this.handleChange(e) }}></input>
                                        <br /><span id="pnr_error" className="errorbox" style={{ display: "none" }}>Enter PNR number</span>
                                    </div>
                                </div>
                            }
                            <div id="stationontoast" className="addontoast">{stations.msg}</div>
                            {(stations.msg) &&
                                this.handleStationToast(this.props)
                            }
                            <button type='submit' id="order-food" name="proceed-journey" className="proceed-journey" onClick={() => { this.submit(homeTab); window.navigator.vibrate(50); }} >
                                <span>ORDER NOW</span>
                                <span className="loader-wrap"><img src={loader} className="loader-icon" alt="loading"></img></span>
                            </button>
                            {(pnr !== '' || trainNo != '' || boardingStation != '') &&
                                <a onClick={() => this.handleClear()} className="clear-journey">Clear</a>
                            }

                            {/* <div className="recmnd-srchs">
                            <h4><img src={recomndIcon} alt="img"></img> Recommended Search</h4>
                            <div className="search-box">
                                <h5>1424547095</h5>
                                <span>20-02-2020</span>
                                <p>12625 - Trivandrum - New Delhi Kerala Express</p>
                            </div>
                            <div className="search-box">
                                <h5>1424567095</h5>
                                <span>20-02-2020</span>
                                <p>12625 - Trivandrum - New Delhi Kerala Express</p>
                            </div>
                            <div className="search-box">
                                <h5>1424567095</h5>
                                <span>20-02-2020</span>
                                <p>12625 - Trivandrum - New Delhi Kerala Express</p>
                            </div>
                            <div className="search-box">
                                <h5>1424567095</h5>
                                <span>20-02-2020</span>
                                <p>12625 - Trivandrum - New Delhi Kerala Express</p>
                            </div>
                        </div> */}

                            {/* <div className="trndng-srchs">
                            <h4><img src={trndngIcon} alt="img"></img> Trending Search</h4>
                            <div className="p-2">
                                <div className="trndng-box">
                                    <p><img src={trndngIcon} alt="img"></img> 12625 Kerala SF Express</p>
                                </div>
                                <div className="trndng-box">
                                    <p><img src={trndngIcon} alt="img"></img> 12625 Kerala SF Express</p>
                                </div>
                                <div className="trndng-box">
                                    <p><img src={trndngIcon} alt="img"></img> 12625 Kerala SF Express</p>
                                </div>
                                <div className="trndng-box">
                                    <p><img src={trndngIcon} alt="img"></img> 12625 Kerala SF Express</p>
                                </div>
                                <div className="trndng-box">
                                    <p><img src={trndngIcon} alt="img"></img> 12625 Kerala SF Express</p>
                                </div>
                                <div className="trndng-box">
                                    <p><img src={trndngIcon} alt="img"></img> 12625 Kerala SF Express</p>
                                </div>
                            </div>
                        </div> */}

                        </div>
                    </div>
                    <div className='coupon-banner'>
                        <img src={couponBanner} alt='coupon-img' />
                    </div>
                    <div class="irctc-authorized">
                        <img src={food_img} alt="" class="auth-food-img" />
                        <div class="rt-cntnt">
                            <img src={irctc_logo} />
                            <p>Most trusted <span>IRCTC authorised eCatering</span> partner</p>
                        </div>
                    </div>
                </div >
            )
        } else {
            return (
                <div></div>
            )
        }
    }
}

const mapStateToProps = createStructuredSelector({
    boardingDate: selectBoardingDate,
    pnr: selectPnr,
    trainNo: selectTrainNo,
    boardingStation: selectBoardingStation,
    cartCount: selectCartItemsCount,
    stations: selectStations,
    homeTab: selectHomeTab,
    version: selectVersion,
    stationFetching: selectStationFetching

})

const mapDispatchToProps = dispatch => ({
    setDate: date => dispatch(setBoardingDate(date)),
    setPnr: pnr => dispatch(setPnr(pnr)),
    setStationAll: () => dispatch(setStationsDetailAllStart()),
    setHomeTab: tab => dispatch(setHomeTab(tab)),
    setVersion: version => dispatch(setVersion(version)),
    setTrainNo: trainNo => dispatch(setTrainNo(trainNo)),
    setBoardingStation: station => dispatch(setBoardingStation(station)),
    emptyCart:() => dispatch(removeAllItemFromCart())
})

export default connect(mapStateToProps, mapDispatchToProps)(HomeJourneyDetails);